import React, { useState, useContext, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useWindowSize } from 'react-use';
import { logoutMenu } from '../../menu';
import useDarkMode from '../../hooks/useDarkMode';
import Collapse from '../../components/bootstrap/Collapse';
import Navigation, { NavigationLine } from '../Navigation/Navigation';
import Icon from '../../components/icon/Icon';
import useNavigationItemHandle from '../../hooks/useNavigationItemHandle';
import AuthContext from '../../contexts/authContext';
import ThemeContext from '../../contexts/themeContext';
import Popovers from '../../components/bootstrap/Popovers';
import AvatarIMG from '../../assets/img/wanna/wanna1.png';
import { useUser } from '../../contexts/UserContext';
import Button from '../../components/bootstrap/Button';

const User = () => {
	const { width } = useWindowSize();
	const { setAsideStatus } = useContext(ThemeContext);
	const { userData, setUser } = useContext(AuthContext);

	const navigate = useNavigate();
	const handleItem = useNavigationItemHandle();
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	const [collapseStatus, setCollapseStatus] = useState<boolean>(false);
	const { t } = useTranslation(['translation', 'menu']);
	const storedData = localStorage.getItem('HRMS-data');
	const { user } = useUser();

	return (
		<>
			<div
				className={classNames('user', { open: collapseStatus })}
				role='presentation'
				onClick={(e: React.MouseEvent) => {
					e.stopPropagation();
					// setCollapseStatus(!collapseStatus)
				}}>
				<div className='user-avatar'>
					<img
						srcSet={userData?.srcSet}
						src={AvatarIMG}
						alt='Avatar'
						width={128}
						height={128}
					/>
				</div>

				<div className='user-info'>
					<div className='user-name overflow-hidden'>
						{`${user?.fName} ${user?.lName}`}
					</div>
				</div>
				<div className='user-info'>
					<div>
						<Button
							type='button'
							className='btn brand-aside-toggle'
							aria-label='Toggle Aside'
							onClick={() => setCollapseStatus(!collapseStatus)}>
							{collapseStatus ? (
								<Icon icon='KeyboardArrowDown' />
							) : (
								<Icon icon='KeyboardArrowUp' />
							)}
						</Button>
					</div>
				</div>
			</div>

			<Collapse isOpen={collapseStatus} className='user-menu'>
				<nav aria-label='aside-bottom-user-menu'>
					<div className='navigation'>
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() =>
								navigate(
									`/profile`,
									// @ts-ignore
									handleItem(),
								)
							}>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon icon='AccountCircle' className='navigation-icon' />
									<span className='navigation-text'>
										{t('menu:Profile') as ReactNode}
									</span>
								</span>
							</span>
						</div>
						{/* <div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								setDarkModeStatus(!darkModeStatus);
								handleItem();
							}}>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon
										icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
										color={darkModeStatus ? 'info' : 'warning'}
										className='navigation-icon'
									/>
									<span className='navigation-text'>
										{darkModeStatus
											? (t('menu:DarkMode') as ReactNode)
											: (t('menu:LightMode') as ReactNode)}
									</span>
								</span>
							</span>
						</div> */}
					</div>
				</nav>
				<NavigationLine />
				<nav aria-label='aside-bottom-user-menu-2'>
					<div className='navigation'>
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								if (setUser) {
									setUser('');
								}
								if (width < Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)) {
									setAsideStatus(false);
								}
								navigate(`/}`);
							}}
						/>
					</div>
				</nav>
				<span className='navigation-link navigation-link-pill'>
					<Navigation menu={logoutMenu} id='aside-dashboard-logout' />
				</span>
			</Collapse>
		</>
	);
};

export default User;
